import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ProcessActions, { processActionTypes } from '@Actions/production/processActions';
import ProcessServices from '../../services/production/processServices';

/**
 * @param action
 */
function* _createProcess(action) {
  try {
    yield put(ProcessActions.createProcessLoading(true));
    const process = yield ProcessServices.createProcess(action.payload);
    if (process.success) {
      yield put(TrackerActions.trackAction(processActionTypes.CREATE_PROCESS.SUCCESS, process.data));
      notification.open({
        type: 'success',
        message: ' Process successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(process?.data?.[0]);
    } else {
      notification.open({
        type: 'error',
        message: process?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProcessActions.createProcessLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(ProcessActions.createProcessLoading(false));
    yield put(TrackerActions.trackAction(processActionTypes.CREATE_PROCESS.ERROR, error));
  }
}

/**
 *
 */
function* createProcess() {
  yield takeLatest(processActionTypes.CREATE_PROCESS.REQUEST, _createProcess);
}

/**
 * @param action
 */
function* _updateProcess(action) {
  try {
    yield put(ProcessActions.updateProcessLoading(true));
    const process = yield ProcessServices.updateProcess(action.payload);
    if (process.success) {
      yield put(TrackerActions.trackAction(processActionTypes.UPDATE_PROCESS.SUCCESS, process.data));
      notification.open({
        type: 'success',
        message: 'Process successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(ProcessActions.updateProcessLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: process?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ProcessActions.updateProcessLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ProcessActions.updateProcessLoading(false));
    yield put(TrackerActions.trackAction(processActionTypes.UPDATE_PROCESS.ERROR, error));
  }
}

/**
 *
 */
function* updateProcess() {
  yield takeLatest(processActionTypes.UPDATE_PROCESS.REQUEST, _updateProcess);
}

/**
 * @param action
 */
function* _getProcesses(action) {
  try {
    yield put(ProcessActions.getProcessesLoading(true));
    const {
      orgId, page, limit, searchKeyword,
    } = action;
    const processes = yield ProcessServices.getProcesses(orgId, page, limit, searchKeyword);
    yield put(ProcessActions.getProcessesSuccess(processes));
    yield put(ProcessActions.getProcessesLoading(false));
  } catch (error) {
    yield put(ProcessActions.getProcessesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(processActionTypes.GET_PROCESSES.ERROR, error));
  }
}

/**
 *
 */
function* getProcesses() {
  yield takeLatest(processActionTypes.GET_PROCESSES.REQUEST, _getProcesses);
}

/**
 * @param action
 */
function* _getProcessById(action) {
  try {
    yield put(ProcessActions.getProcessByIdLoading(true));
    const {
      tenantId, tenantSellerId, processId, searchKeyword,
    } = action;
    const selectedProcess = yield ProcessServices.getProcess(tenantId, tenantSellerId, processId, searchKeyword);
    yield put(ProcessActions.getProcessByIdSuccess(selectedProcess));
    yield put(ProcessActions.getProcessByIdLoading(false));
  } catch (error) {
    yield put(ProcessActions.getProcessByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(processActionTypes.GET_PROCESS_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getProcessById() {
  yield takeLatest(processActionTypes.GET_PROCESS_BY_ID.REQUEST, _getProcessById);
}

/**
 * @param action
 */
function* _updateProcessStatus(action) {
  try {
    yield put(ProcessActions.updateProcessStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const process = yield ProcessServices.updateProcessStatus(payload);

    if (process.success) {
      notification.open({
        type: 'success',
        message: ' Process successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: process?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProcessActions.updateProcessStatusLoading(false));
  } catch (error) {
    yield put(ProcessActions.updateProcessStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(processActionTypes.UPDATE_STATUS_PROCESS.ERROR, error));
  }
}

/**
 *
 */
function* updateProcessStatus() {
  yield takeLatest(processActionTypes.UPDATE_STATUS_PROCESS.REQUEST, _updateProcessStatus);
}

/**
 * @param action
 */
function* _deleteProcess(action) {
  try {
    yield put(ProcessActions.deleteProcessLoading(true));
    const process = yield ProcessServices.deleteProcess(action.payload);

    if (process.success) {
      notification.open({
        type: 'success',
        message: ' Process successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: process.message,
        description: process?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProcessActions.deleteProcessLoading(false));
  } catch (error) {
    yield put(ProcessActions.deleteProcessLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(processActionTypes.DELETE_PROCESS.ERROR, error));
  }
}

/**
 *
 */
function* deleteProcess() {
  yield takeLatest(processActionTypes.DELETE_PROCESS.REQUEST, _deleteProcess);
}

/**
 *
 */
export default function* processSaga() {
  yield all([
    createProcess(), getProcesses(), updateProcess(), getProcessById(), updateProcessStatus(), deleteProcess(),
  ]);
}
